module.exports = __webpack_public_path__ + "static/media/dashboardIcon.ac97184c.svg";